import React from 'react';
import {Box, Grid} from "@mui/material";

// internal
import Quiz from "../../components/Quiz";
import {
  StyledWrapper,
  StyledBody,
  StyledTimer,
  StyledNote
} from "./styles";

function TrainingStep(props) {
  const {
    step, totalStep, training, countdown, onScroll,
    changeAnswer, answered, showAnswer, answerCorrect, setAutoShowAns
  } = props;

  const formatTimer = (timer) => {
    if (!timer) return "";
    const minute = Math.floor(timer / 60);
    let second = timer % 60;
    if (second < 10) second = '0' + second;
    return minute + ":" + second;
  }

  return (
    <StyledWrapper>
      <Grid container direction="column" wrap="nowrap" sx={{ height: '100%' }}>
        <Grid>
          <Box mb={1}>
            <Grid container spacing={1} justifyContent={step === totalStep ? "center" : "space-between"} alignItems="center" wrap="nowrap">
              <Grid>
                <Box component="h2" m={0}>{training.title}</Box>
              </Grid>
              <Grid>
                <StyledTimer>{formatTimer(countdown)}</StyledTimer>
              </Grid>
            </Grid>
          </Box>
        </Grid>
        <StyledBody id="training-body" onScroll={onScroll} onClick={onScroll}
              step={step} totalStep={totalStep}
        >
          <Box>
            <div dangerouslySetInnerHTML={{__html: training.content}} />
          </Box>
          <Box>
            <Quiz quizList={training.quiz_list}
                  changeAnswer={changeAnswer}
                  answered={answered}
                  showAnswer={showAnswer}
                  setAutoShowAns={setAutoShowAns}
                  disabled={(training.data?.completed) || answerCorrect}
            />
          </Box>
        </StyledBody>
        {training?.note && (
          <Grid>
            <StyledNote>{training.note}</StyledNote>
          </Grid>
        )}
      </Grid>
    </StyledWrapper>
  )
}

export default TrainingStep;